import {Component, OnInit} from '@angular/core';
import {UserResponseModel} from '../../models/user-response.model';
import {FormBuilder, FormGroup} from '@angular/forms';
import {UserRequestModel} from '../../models/user-request.model';
import {Router} from '@angular/router';
import {StorageHelperService} from '../../services/storage-helper.service';
import {SharedService} from '../../services/shared.service';
import {TokenManager} from '../../services/TokenManager';
import {CalcApiService} from '../../services/calc-api.service';
import {Toast, ToasterService} from 'angular5-toaster/dist';
import {UserAkModel} from '../../models/user-ak.model';


@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.less']
})
export class LogACodComponent implements OnInit {

  userResponseModel: UserResponseModel = new UserResponseModel();
  UserAkModel: UserAkModel = new UserAkModel();
  loader = false;
  userForm: FormGroup;
  type: string;


  constructor(private router: Router, private fb: FormBuilder, private authenticationService: SharedService, private tokenManager: TokenManager, private webShopApiService: CalcApiService, private toasterService: ToasterService) {
    this.userForm = fb.group({
      'acode': [null]
    });

    this.userResponseModel = StorageHelperService.GetData('userResponseModel');
    if (!this.userResponseModel) {
      //  this.router.navigate(['home']);
    }
  }

  ngOnInit() {
    sessionStorage.clear();
  }
  submitCalc() {
    const acode = this.userForm.controls['acode'].value;
    if (acode.length > 3)
    {
      this.loader = true;
      this.UserAkModel.Token =  acode;
        this.UserAkModel.UserName =  this.userResponseModel.userName;

      this.webShopApiService.userAKCheck(this.UserAkModel)
        .subscribe(
          (response) => {
            this.userResponseModel = new UserResponseModel();
            this.userResponseModel = response;

            if(this.userResponseModel.active === 1) {
              // this.authenticationService.login(this.userResponseModel);

              this.tokenManager.generateNewToken(this.userResponseModel);
              this.authenticationService.login(this.userResponseModel);
              StorageHelperService.PushData('userResponseModel', this.userResponseModel);
              this.router.navigate(['homemenu'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });
            } else {
              const toast: Toast = {
                type: 'error',
                title: 'Greška',
                body: 'Proverite dobijeni aktivacioni kod u mail-u i probajte ponovo!',
                showCloseButton: true
              };
              this.toasterService.pop(toast);
            }

            this.loader = false;
          },
          (error) => {
            console.log(error);
            const toast: Toast = {
              type: 'error',
              title: 'Greška',
              body: 'Proverite dobijeni aktivacioni kod u mail-u i probajte ponovo!',
              showCloseButton: true
            };
            this.toasterService.pop(toast);
            this.loader = false;

          }
        );
    }
    ///////////////////////////////////////////////////////////////////////////////////////

      // this.router.navigate(['homemenu'], { queryParams: { type: this.type}, queryParamsHandling: 'merge' });

  }


}



// WEBPACK FOOTER //
// ./src/app/pages/LoginACod/LogACod.component.ts